import React, {useRef, useEffect} from 'react';
import useLog from '../hooks/useLog';
const AudioPlayer = ({ src, active=false }) => {
  const playerRef = useRef(null);
  const { LogInfo } = useLog();

  useEffect(() => {
    LogInfo('AudioPlayer useEffect called, active=' + active + ' src=' + src);
    if (playerRef.current ) {

      if(active) {
        LogInfo('playing audio');
        playerRef.current.play();
      }
      else{
        LogInfo('pausing audio');
        playerRef.current.pause();
      }
    }
  }, [active]);

  return (
      <audio ref={playerRef} src={src} loop={active}/>
  );
};

export default AudioPlayer;